import type { Opt, Question } from "@/data/types";

import "./styles.css";
import { QuestionText } from "./components/QuestionText";
import { Button } from "./components/QuestionButton";

interface QuestionPanelProps {
  index: number;
  layer: Question[];
  changeKey: (layer: number, index: number) => void;
}

const ButtonOptions = ({
  options,
  setKeyLayer,
}: {
  options?: Opt[];
  setKeyLayer: (key: number, layer: number) => void;
}) => {
  return (
    <div style={{ width: "100%" }}>
      {options &&
        options.map((btn, i) => (
          <Button key={i} onClick={() => setKeyLayer(btn.key, btn.layer_key)}>
            {btn.answer}
          </Button>
        ))}
    </div>
  );
};

export const QuestionPanel = ({
  layer,
  index,
  changeKey,
}: QuestionPanelProps) => {
  return (
    <>
      <QuestionText text={layer[index]?.q ?? ""} />
      <ButtonOptions options={layer[index]?.opts} setKeyLayer={changeKey} />
    </>
  );
};
